import { useAbTestComponent, loadUsualComponent } from "@hook";
import { inject, observer } from "mobx-react";

import AB_3274 from "./AB_3274";

import Default from "./Default";

const abTests = {
    dev_3274__v2: loadUsualComponent(AB_3274),
    dev_3632__v2: loadUsualComponent(AB_3274),
};

const Cookies = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default });

        return <Specified {...props} />;
    }),
);

export default Cookies;
